import React from 'react';
import { Button, ProgressBar, Form, Col, Row } from 'react-bootstrap'
import * as _ from 'lodash'
import IosCalendar from 'react-ionicons/lib/IosCalendar'
import { copyObject, randomId } from '../../utils'

import { CurrentScreenT, ClientExtendsT, FieldsCreateJobT } from './Booking'
import IosArrowBack from 'react-ionicons/lib/IosArrowBack'
import IosArrowForward from 'react-ionicons/lib/IosArrowForward'

import NumberFormatValidate from '../../components/NumberFormatValidate'
import InputDatePickerT from '../../components/InputDatePicker/InputDatePicker'
import TimePicker from 'rc-time-picker'
import { css } from 'glamor'
import moment from 'moment'
import Colors from '../../constants/colors'
import { CompanyT, VariablesT } from '../../types/Company'
import { AxiosInstance, unauthorizedRequest } from '../../utils/RequestMethods'
import config from '../../constants/config'
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading'
import { isEmpty } from '../../utils/validator';
import { getDirections } from '../../utils/MapboxClient';
import { getDistance } from '../../utils/helperMaps';
import { ActivityT, JobTypeTStrings, LocationT } from '../../types/Job';
import { ClientObj } from '../../types/Users';


const now = moment().hour(0).minute(0);
const styles = {
    left: {
        marginLeft: 0
    },
    required: {
        color: 'red'
    },
    inputTimePicker: css({
        // border: "none !important",

        backgroundColor: "#fff !important",
        borderBottom: "1px solid #ccc !important",
        padding: ".3rem 0.55rem 0 !important",
        // height: "2.2rem !important",
        fontSize: "1rem !important",
    }),
    popupClassName: css({
        ' input': {
            border: "none !important",
            borderBottom: "1px solid #ccc !important",
            padding: ".3rem 0.55rem 0 !important",
            // height: "2.2rem !important",
            fontSize: "1rem !important",

        },

    })
}
export interface FieldsJobQuestionsT {
    useTruck: boolean,
    duration: number,
    moveDate: string,
    startTime: string,
}

export const initFieldsJobQuestions: FieldsJobQuestionsT = {
    useTruck: null,
    duration: null,
    moveDate: null,
    startTime: null,
}


export type IScreenJobQuestionsProps = {
    tokenUser: string
    token: string
    company: CompanyT
    locations: Array<LocationT>
    fields: FieldsJobQuestionsT
    companyVariables: VariablesT
    onChangeeFields(fields: FieldsJobQuestionsT): void
    goBack() : void
    nextScreen(fields : FieldsCreateJobT): void
    handle? : string

}

const ScreenJobQuestions : React.FC<IScreenJobQuestionsProps> = (props) => {

    const [client, setClient] = React.useState<ClientExtendsT>(copyObject(ClientObj))
    const [fields, setFields] = React.useState(initFieldsJobQuestions);
    const [validated, setValidated] = React.useState<boolean>(false)
    const [validatedStartTime, setValidatedStartTime] = React.useState<boolean>(false)

    const formRef = React.useRef(null)
    const [result, setResult] = React.useState({
        loading: false,
        msg: '',
        isSuccess: false,
        showMsg: false,
    });
    React.useEffect(() => {
      console.log("company",props.company)
        setFields(props.fields)
    }, []);


    React.useEffect(() => {

        // setFields((draft) => {
        //     draft.locations = props.locations
        //     return draft;
        // })
    }, []);

    const onChangeFields = (key: string, value: any) => {
        let tempFields = copyObject(fields)
        tempFields[key] = value
        setFields(tempFields)
        props.onChangeeFields(tempFields)

        // setTimeout(() => {
        //     console.log("prepareParamsCreateJob", prepareParamsCreateJob())
        // }, 1000);
    }



    const createNewJob = async (): Promise<string> => {
        let jobType = await getJobType(props.locations, fields.useTruck)
        let locations = prepareLocationsForParams(props.locations, fields.moveDate, fields.startTime, fields.duration)
        let params : FieldsCreateJobT = {
            jobType: jobType,
            token: props.token,
            duration: fields.duration,
            moveDate: fields.moveDate,
            startTime: moment(fields.startTime).format("MM/DD/YYYY HH:mm:ss"),
            locations: locations,
        }
        props.nextScreen(params)
        return ""
    }


    /**
     *
     * @param locations
     * @returns
     */
    const parseDistance = async (locations: Array<LocationT>): Promise<number> => {
        let distance = 0
        try {

            if (locations.length > 2) {
                let result = await getDirections(locations)
                distance = result.distanceMailes
            } else if (locations.length == 2) {
                distance = getDistance(locations[0], locations[1])
            }
        } catch (error) {
            console.log("error", error)
        }
        return distance
    }


    /**
     * If truck and
     * 1) one location, then it's Intrastate Local,
     * 2) two locations, but within the the local intrastate margin, then Intrastate Local,
     * 3) two locations that are longer than the local intrastate margin, Intrastate Long-distance Moving,
     * 4) If within two different states, 'Interstate'
     * @param locations
     * @param useTruck
     * @returns
     */
    const getJobType = async (locations: Array<LocationT>, useTruck: boolean): Promise<JobTypeTStrings> => {
        let jobType: JobTypeTStrings = null


        if (useTruck) {
            if (props.locations.length == 1) {
                jobType = "intrastate_local"
            } else if (props.locations.length > 1) {
                let inState = locationsInState(locations)
                if (!inState) {
                    return "interstate"
                }

                let distance = await parseDistance(locations)
                console.log("distance", distance)
                if (distance > props.companyVariables.localIntrastateMargin.value) {
                    jobType = "intrastate_long"
                } else {
                    jobType = "intrastate_local"
                }
            }

        } else {
            jobType = 'moving_labor'
        }

        return jobType

    }



    const prepareLocationsForParams = (locations: Array<LocationT>, moveDate: string, startTime: string, duration: number): Array<LocationT> => {
        let newLocations = []
        let moveDateFormat = moment(moveDate).format('MM/DD/YYYY')
        // console.log("startTime", startTime)
        const date = moment(`${moveDateFormat} ${moment(startTime).format('h:mm A')}`)
        let totalDuration = 0
        let activityStartTime = date.toDate().toString()
        // console.log("activityStartTime", activityStartTime)
        locations.map((location, index) => {
            let newLocation = { ...location }
            let activities: Array<ActivityT> = []

            totalDuration = totalDuration + getEstimatedTime(index, locations.length, duration, totalDuration)

            const totalDurationMinutes = totalDuration * 60

            const endTime = moment(activityStartTime).add((totalDurationMinutes), "minutes")
            const activityType = index == 0 ? "load" : "unload"
            activities.push({
                index: 0,
                id: randomId(),
                activityDate: moveDate,
                activityType: activityType,
                startTime: activityStartTime,
                endTime: endTime.toDate().toString(),
            })
            // console.log("startTime", moment(activityStartTime).format("MM/DD/YYYY h:mm:ss A"))
            // console.log("endTime", endTime.format("MM/DD/YYYY h:mm:ss A"))

            // set next startTime from endTIme
            activityStartTime = endTime.toDate().toString()
            newLocation.activities = copyObject(activities)
            newLocations.push(newLocation)
        })

        return newLocations
    }


    /**
     *
     * @param duration
     * @returns
     */
    const round15Minutes = (duration: number): number => {
        let minute = duration * 60
        return (Math.round(minute / 15) * 15) / 60
    }

    /**
     * getEstimatedTime
     */
    const getEstimatedTime = (index: number, length: number, duration: number, totalDuration: number): number => {
        let estimatedTime = 0
        if (length <= 1) {
            estimatedTime = duration
        } else if (length == 2) {
            if (index == 0) {
                estimatedTime = round15Minutes(duration * (2 / 3))
            } else {
                estimatedTime = duration - totalDuration
            }
        } else {
            if (index == 0) {
                estimatedTime = round15Minutes(duration * (1 / 3))
            } else if (index == (length - 1)) {
                estimatedTime = duration - totalDuration
            } else {
                estimatedTime = round15Minutes(duration * (1 / 3))
            }
        }

        return estimatedTime
    }


    /**
     * locationsInState
     * @param locations
     * @returns
     */
    const locationsInState = (locations: Array<LocationT>): boolean => {
        let findLocation = locations.find((loction, index) => {
            return locations.find((item) => {
                return item.addressState != loction.addressState
            })
        })
        return !findLocation ? true : false
    }


    const checkValidity = () => {
        if (formRef && formRef.current) {
            let validityForm = formRef.current.checkValidity() && !isEmpty(fields.startTime) && !isEmpty(fields.moveDate);
            return validityForm
        }
        return false
    }


    const isValidStartTime = (): boolean => {
        return (validated && fields.startTime == null) == false
    }


    return (
        <div>
            <ProgressBar
                now={100}
                style={{ marginBottom: 30 }}
                variant="info" />
            <p>Fill out the questions below to continue booking your job.</p>
            <hr />
            <Form
                noValidate
                ref={formRef}
                validated={validated}

            // onSubmit={onSubmit}
            >
                <Form.Group>
                    <Form.Label>Do you need a truck? <span style={styles.required}>*</span></Form.Label>
                    <Form.Control
                        required
                        as="select"
                        // isValid={isEmail(client.email)}
                        value={`${fields.useTruck}`}
                        onChange={(e) => {
                            onChangeFields('useTruck', e.target.value)
                        }}>
                        <option></option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                        You must select if you need a truck for your move.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                    <Form.Label>How many hours do you think your job will take? <span style={styles.required}>*</span></Form.Label>

                    <NumberFormatValidate
                        onlyNumeric
                        required
                        customInput={Form.Control}
                        validated={validated}
                        // className="input-material"
                        type="text"
                        defaultValue={`${fields.duration}`}
                        value={`${fields.duration}`}
                        onValueChange={(values) => {
                            const { formattedValue, value, floatValue } = values;
                            onChangeFields('duration', floatValue)
                        }}
                        customValidate={(floatValue) => {
                            return _.isNumber(floatValue) && floatValue > 0
                        }}
                        mask="_" />


                    <Form.Control.Feedback type="invalid">
                        You must input estimated job duration.
                    </Form.Control.Feedback>
                </Form.Group>
                <Row>
                    {/* <Form.Label>Choose a time for your move. <span style={styles.required}>*</span></Form.Label> */}
                    <Col xs={8}>
                        <Form.Group>
                            <Form.Label>Choose a date for your move. <span style={styles.required}>*</span></Form.Label>
                            <InputDatePickerT
                                required
                                validated={validated}
                                id={`moveDate`}
                                // className="input-material"
                                style={{ width: '100%' }}
                                selectedDate={`${fields.moveDate ? fields.moveDate : ""}`}

                                onChangeDate={(val) => {
                                    onChangeFields('moveDate', val)

                                }}
                                onChange={(date) => {

                                }}
                                dateFormat="MM/dd/yyyy"
                                // showTimeSelect
                                placeholder=""
                                textFeedBack="You must input a move time."
                            />
                            <Form.Control.Feedback type="invalid">
                                You must input a move time.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col xs={4}>
                        <Form.Group className='d-flex flex-column'>
                            <Form.Label>Start Time</Form.Label>
                            <TimePicker
                                showSecond={false}
                                // required={true}
                                // style={{ width: "100%" }}
                                // defaultValue={now}
                                minuteStep={15}
                                defaultOpenValue={now}
                                value={fields.startTime ? moment(fields.startTime) : null}
                                inputClassName={` form-control custom-height-field ${validatedStartTime ? isValidStartTime() ? "is-valid" : "is-invalid" : ""} ${styles.inputTimePicker}`}
                                popupClassName={` ${styles.popupClassName}`}
                                onChange={(value) => {
                                    if (value == null) {
                                        onChangeFields('startTime', null)


                                    } else {
                                        onChangeFields('startTime', value.toDate().toString())

                                    }

                                    setValidatedStartTime(true)

                                    // console.log("toDate", value.toDate())
                                    // console.log(value && value.format(format12Hours));
                                }}
                                format={'h:mm A'}
                                use12Hours
                                inputReadOnly
                            />
                            {(validatedStartTime && !isValidStartTime()) && <Form.Text className="" style={{ color: Colors.red }}>
                                You must input a valid time.
                            </Form.Text>}
                            {fields.startTime == null && <Form.Control.Feedback type="invalid">
                                You must input a valid time.
                            </Form.Control.Feedback>}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    {result.showMsg && <div>
                        <span style={{ color: result.isSuccess ? Colors.green : Colors.red }} >{result.msg}</span>
                    </div>}
                </Row>

                <Button
                    style={styles.left}
                    onClick={() => {
                        props.goBack()
                    }}
                    variant="success">
                    <IosArrowBack
                        color="white" />
                    Back
                </Button>
                <ButtonLoading
                noShowResultMessageSuccess={true}
                    disabled={ !checkValidity()}
                    style={styles.left}
                    timeShowMsg={0}
                    type="submit"
                    onClickFetching={async (e): Promise<string> => {
                        e.preventDefault();
                        e.stopPropagation()

                        setValidatedStartTime(true)
                        setValidated(true)
                        if (!checkValidity()) {

                            throw new Error("Make sure data is inputted correctly.")
                        }


                        return await createNewJob()
                    }}
                    variant="success">

                    Next
                    <IosArrowForward
                        color="white" />
                </ButtonLoading>

            </Form>
        </div>

    );
}

export default ScreenJobQuestions
